import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-brand">
          <img src="img/cookie4.png" alt="LaCookie logo" style={{ width: '150px' }} />
          <h2>LaCookie</h2>
          <p>Sweet moments, delivered.</p>
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/ourstory">About</Link></li>
            <li><Link to="/order">Products</Link></li>
            <li><Link to="/locations">Contact</Link></li>
            <li><Link to="/blog">Blog</Link></li>
          </ul>
        </div>

        <div className="footer-newsletter">
          <h4>Join Our Newsletter</h4>
          <p>Be the first to know about new treats!</p>
          <form className="newsletter-form">
            <input type="email" placeholder="Enter your email" required />
            <button type="submit">Subscribe</button>
            <p>By signing up, you agree to our Privacy Policy*.</p>
          </form>
        </div>

        <div className="footer-social">
          <h4>Social</h4>
      <div className="social-icons">
  <a href="https://facebook.com" target="_blank" rel="noreferrer">
    <FontAwesomeIcon icon={faFacebook} size="lg" />
  </a>
  <a href="https://instagram.com" target="_blank" rel="noreferrer">
    <FontAwesomeIcon icon={faInstagram} size="lg" />
  </a>
  <a href="https://tiktok.com" target="_blank" rel="noreferrer">
    <FontAwesomeIcon icon={faTiktok} size="lg" />
  </a>
</div>

        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 LaCookie. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
